import moment from "moment"
import PropTypes from "prop-types"
import React from "react"

import { CalendarDropdown } from "@swipesense/calendar"

import AssetHistoryTableWithData from "../AssetHistoryTable/AssetHistoryTableWithData"
import "./AssetHistoryWithCalendar.scss"

class AssetHistoryWithCalendar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      startAt: props.lastMovedAt
        ? moment
            .utc(props.lastMovedAt)
            .startOf("day")
            .subtract(1, "days")
        : moment
            .utc()
            .startOf("day")
            .subtract(1, "days"),
      endAt: props.lastMovedAt
        ? moment.utc(props.lastMovedAt).startOf("day")
        : moment.utc().startOf("day"),
    }
  }

  onUpdate = (startAt, endAt) => {
    this.setState({
      startAt: startAt,
      endAt: endAt,
    })
  }

  render() {
    return (
      <div className="asset-history-table">
        <CalendarDropdown
          startDate={this.state.startAt}
          endDate={this.state.endAt}
          onUpdate={this.onUpdate}
        />
        <AssetHistoryTableWithData
          id={this.props.id}
          startAt={this.state.startAt}
          endAt={this.state.endAt}
        />
      </div>
    )
  }
}

AssetHistoryWithCalendar.propTypes = {
  id: PropTypes.string.isRequired,
  lastMovedAt: PropTypes.string,
  timeSinceDetected: PropTypes.number,
}

export default AssetHistoryWithCalendar
